<template>
  <input class="form-control" type="text" v-model="currentSelection" readonly v-show="currentSelection" />
  <Autocomplete
    v-show="!currentSelection"
    :max="20"
    class="form-control"
    @input="getMaterialsAsync"
    @onSelect="selectCurrent"
    :results="materials"
  ></Autocomplete>
  <button class="btn btn-outline-secondary" type="button" @click="currentSelection = ''" :disabled="!currentSelection">
    Spremeni
  </button>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useAuth } from "../composition-api/useAuth"
import { searchMaterialsAsync } from "../api"
import SelectMaterial from "./SelectMaterial.vue"

defineOptions({ name: "SearchMaterial" })

const emit = defineEmits(["selected"])

const { fetchAuthAsync } = useAuth()

const materials = ref([])
const currentSelection = ref(null)

// a v-on value is parsed as statements only while it contains a `;`, otherwise as a single
// expression - so multi-statement handlers live here, where formatting cannot invalidate them
const selectCurrent = (e) => {
  emit("selected", e)
  currentSelection.value = e.name
}

const getMaterialsAsync = async (q) => {
  materials.value = await searchMaterialsAsync(fetchAuthAsync, "q", q)
}

watch(currentSelection, (newValue, oldValue) => {
  if (oldValue !== "" && newValue === "") {
    emit("selected", "")
  }
})
</script>
